<template>
  <div class="h100vh-116">
    <div class='h-ainfoBg'>
      <div class='h-ainfo'>
        <span class='icon hero-icon hero-icon-detailcode'></span>
        <span>{{$t('MCS.choosed')}} {{ chooseCount }} {{$t('MCS.num')}}</span>
      </div>
    </div>
    <div style="height: calc(100vh - 200px) !important;">
      <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :allowResizing='false'
                :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='getChooseCount'>
        <e-columns>
          <e-column type='checkbox' headerText='areaId' width='50' textAlign='Center'></e-column>
          <e-column field='areaId' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.areaId")' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='netType' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.netType")'
                    :formatter='netTypeFormat' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='plmnId' clipMode='EllipsisWithTooltip' headerText='PLMN' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='enbId' clipMode='EllipsisWithTooltip' headerText='eNB ID' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='cellId' clipMode='EllipsisWithTooltip' headerText='Cell ID' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='areaName' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.areaName")' width='20%'
                    textAlign='Center'></e-column>
          <e-column field='description' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.description")' width='20%'
                    textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo'
                 :totalRecordsCount='page.totalCount'></ejs-pager>
    </div>
    <CustomDialog ref='addAreaPage' :element='dialog.element.eleAddArea' :styles='dialog.stylesAdd'>
      <template v-slot:dialog-content>
        <AddAreaDialog ref='addArea' opCode='0' :neid='info.neid'></AddAreaDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='modAreaPage' :element='dialog.element.eleModArea' :styles='dialog.stylesAdd'>
      <template v-slot:dialog-content>
        <AddAreaDialog ref='modArea' opCode='1' :neid='info.neid'></AddAreaDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='superSearchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch'>
      <template v-slot:dialog-content>
        <SuperSearch ref='superSearch' :neid='info.neid' :userNumValue='userNumSearch'
                     :reFreshGrid='reFreshGrid'></SuperSearch>
      </template>
    </CustomDialog>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import {ContextMenu, Edit, Reorder, Resize} from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../../common/CustomDialog';
  import AddAreaDialog from './dialog/AddAreaDialog';
  import SuperSearch from './dialog/SearchDialog';
  import commonJS from '../common';

  export default {
    name: 'AreaTable',
    components: {
      CustomDialog,
      AddAreaDialog,
      SuperSearch
    },
    mixins: [commonJS],
    data() {
      return {
        data: {},
        gpsVif: false,
        groupId: '',
        userNumSearch: '',
        info: {
          neid: '',
          vpnid: '',
          vpnclass: ''
        },
        page: {
          pageNo: '1',
          pageSize: '100',
          totalCount: '0',
          pageCount: '0',
        },
        neid: '',
        node: '',
        equipmentIPId: '',
        vo: {
          flag: '',
          participantType: ''
        },
        chooseCount: 0,
        dialog: {
          styles: {
            width: '810px',
            height: '760px',
            model: true,
            visible: false
          },
          stylesAdd: {
            width: '810px',
            height: '400px',
            visible: false,
            model: true
          },
          stylesGroupList: {
            width: '30%',
            height: '80%',
            visible: false,
            model: true
          },
          stylesSearch: {
            width: '400px',
            height: '270px',
            visible: false,
            model: true
          },
          element: {
            eleAddArea: {
              target: this.$refs.areatable,
              refName: 'eleAddArea',
              buttonGroup: [
                {click: this.closeAddAreaPage, buttonModel: {content: this.$t('MCS.cancle')}},
                {click: this.saveAddArea, buttonModel: {content: this.$t('MCS.confirm'), isPrimary: true}}
              ],
              title: this.$t('MCS.addArea'),
              isClose: true
            },
            eleModArea: {
              target: this.$refs.areatable,
              refName: 'eleModArea',
              buttonGroup: [
                {click: this.closeModAreaPage, buttonModel: {content: this.$t('MCS.cancle')}},
                {click: this.saveModArea, buttonModel: {content: this.$t('MCS.confirm'), isPrimary: true}}
              ],
              title: this.$t('MCS.modArea'),
              isClose: true
            },
            eleSearch: {
              target: this.$refs.userstable,
              refName: 'eleSearch',
              buttonGroup: [
                {click: this.closenSuperSearchPage, buttonModel: {content: this.$t('MCS.cancle')}},
                {click: this.saveSuperSearch, buttonModel: {content: this.$t('MCS.confirm'), isPrimary: true}}
              ],
              title: this.$t('MCS.superSearch'),
              isClose: true
            },
          },
        },
        dialogTip: {
          target: this.$refs.grouptable,
          refName: 'dialogList',
          buttonGroup: [
            {click: this.closeDialogListTipPage, buttonModel: {content: this.$t('MCS.cancle')}}
          ],
          title: this.$t('MCS.messageInfo'),
          isClose: true,
        },
        gridTypeEnum: {
          netType: [, , '2G', '3G', '4G', '5G'],
        },
      };
    },
    methods: {
      getGridData(ne = null,delFalg = false) {
        const $this = this;
        $this.page.pageNo = $this.$refs.pager.ej2Instances.currentPage;
        let vo;
        if (ne !== null) {
          $this.info.neid = ne.data.id;
          $this.equipmentIPId = ne.data.equipmentIPId;
          $this.page.pageNo = 1;
        }
        vo = {
          flag: 0,
          areaId: '',
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          vpnId: $this.vpnId,
          vpnClass: $this.vpnClass
        };
        if (delFalg) {
          $this.page.pageNo = 1;
        }
        const params = {
          info: this.setInfo(this.msg.qryUserArea),
          vo: vo,
          page: {
            pageNo: $this.page.pageNo,
            pageSize: $this.page.pageSize
          }
        };
        this.$axios.post(this.requestCommon, params).then((response) => {
          if (response.data) {
            const respData = response.data;
            if (parseInt(respData.errorCode) !== 0) {
              this.$toast('failure', respData.errorString);
              $this.data = null;
              $this.page.totalCount = 0;
            } else {
              const res = response.data;
              const resData = res.resultVal.result;
              $this.data = resData;
              $this.page.totalCount = res.resultVal.totalCnt;
              $this.$refs.grid.clearSelection();

            }
          } else {
            console.log('subscriber error , resp = ', response);
          }
        });
      },

      isChooseNe() {
        if (this.info.neid === '') {
          this.$toast('warning', this.$t('MCS.chooseNe'));
          return false;
        }
        return true;
      }
      ,
      getCheckedData(selectOnly) {
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          this.$toast('warning', this.$t('Common.tips.noSelect'));
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          this.$toast('warning', this.$t('MCS.onlyData'))
          return false;
        }
        return selectedRecords;
      }
      ,

      getCheckedVals(selectOnly = false) {
        const areaId = [];
        if (this.isChooseNe() !== false) {
          // x-> false: 不支持多选   true: 支持多选
          const checkedData = this.getCheckedData(selectOnly);
          for (let i = 0; i < checkedData.length; i++) {
            areaId.push(checkedData[i].areaId);
          }
        }
        return areaId;
      }
      ,

      getChooseCount() {
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        this.chooseCount = selectedRecords.length;
      }
      ,

      /**
       * 打开/关闭/保存  添加群组页面
       */
      openAddAreaPage() {
        if (this.isChooseNe() === false) {
          return;
        }
        this.$refs.addArea.mainHandler();
        this.$refs.addAreaPage.show();
      }
      ,
      closeAddAreaPage() {
        this.$refs.addAreaPage.clear();
        this.$refs.addAreaPage.close();
      }
      ,
      saveAddArea() {
        const $this = this;
        const datas = this.$refs.addArea.getDatas();
        if (datas === false) return;
        const params = {
          vo: datas,
          info: this.setInfo(this.msg.addUserArea),
          log: {
            module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_area',
            execFunName: 'subscriber.addArea',
            exectype: 1,
            //execData: [datas.groupid]
          }
        };
        this.$axios.post(this.requestCommon, params).then((response) => {
          $this.commonResp(response);
          this.getGridData();
        });
        this.$refs.addAreaPage.clear();
        this.$refs.addAreaPage.close();
      }
      ,

      openModAreaPage() {
        const $this = this;
        const areaId = this.getCheckedVals();
        if (areaId.length !== 0) {
          const vo = {
            areaId: this.getCheckedData()[0].areaId,
            flag: 2,
            enterpriseDomain: $this.enterpriseDomain,
            productType: $this.productType,
            vpnId: 0,
            vpnClass: 0,
          };
          const page = {
            pageNo: 1,
            pageSize: 15
          };
          const params = {
            info: this.setInfo(this.msg.qryUserArea),
            vo: vo,
            page: page
          };
          this.$axios.post(this.requestCommon, params).then((response) => {
            const data = response.data.resultVal.result[0];
            this.$refs.modArea.mainHandler(data);
            this.$refs.modAreaPage.show();
          });
        }
      }
      ,
      closeModAreaPage() {
        this.$refs.modAreaPage.clear();
        this.$refs.modAreaPage.close();
      }
      ,
      saveModArea() {
        const $this = this;
        const datas = $this.$refs.modArea.getDatas();
        if (datas === false) return;
        const params = {
          vo: datas,
          info: $this.setInfo($this.msg.modUserArea),
          log: {
            module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_area',
            execFunName: 'subscriber.modArea',
            exectype: 1,
            //execData: [datas.userNum]
          }
        };
        this.$axios.post($this.requestCommon, params).then((response) => {
          $this.commonResp(response);
          $this.getGridData();
        });
        this.$refs.modAreaPage.clear();
        this.$refs.modAreaPage.close();
      }
      ,
      delAreas() {
        const areaId = this.getCheckedVals(false);
        const $this = this;
        if (areaId.length > 0) {
          this.$layer.confirm({
            msg: this.$t('MCS.deleteConfirm'),
            btn2: {
              msg: this.$t('MCS.confirm'),
              func: () => {
                const resObj = [];
                const vo = {
                  enterpriseDomain: $this.enterpriseDomain,
                  productType: $this.productType,
                  //opCount: areaId.length,
                  areaId: areaId[0]
                };
                for (let i = 0; i < vo.opCount; i++) {
                  const resData = {};
                  resData.operObj = areaId[i];
                  resObj.push(resData);
                }
                ;
                const params = {
                  vo: vo,
                  info: this.setInfo(this.msg.delUserArea),
                  log: {
                    module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_area',
                    execFunName: 'subscriber.delArea',
                    exectype: 1,
                    //execData: userNum
                  }
                };
                this.$axios.post(this.requestCommon, params).then((response) => {
                  $this.commonResp(response);
                  this.getGridData(null,true);
                });
              }
            },
            btn1: {
              msg: this.$t('MCS.cancle'),
            }
          });
        }
      }
      ,

      /**
       * 打开/关闭/保存  高级搜索页面
       */
      openSuperSearchPage() {
        if (this.isChooseNe() === false) {
          return;
        }
        this.$refs.superSearchPage.show();
        this.$refs.superSearch.bindValidate();
      }
      ,
      closenSuperSearchPage() {
        this.$refs.superSearchPage.clear();
        this.$refs.superSearchPage.close();
      }
      ,
      saveSuperSearch() {
        if (!this.$refs.superSearch.checkValid()) {
          return;
        }
        this.$refs.superSearch.search();
        this.$refs.superSearchPage.clear();
        this.$refs.superSearchPage.close();
      }
      ,

      setInfo(msgid) {
        return {
          msgid: msgid,
          neid: this.info.neid,
        };
      }
      ,

      clearCondition() {
        this.userNumSearch = '';
        this.$refs.superSearch.setData('');
      }
      ,

      reFreshByNoCondition() {
        this.clearCondition();
        this.getGridData();
      }
      ,

      reFreshGrid(userNum) {
        this.userNumSearch = userNum;
        this.getGridData();
      }
      ,

      closeDialogListTipPage() {
        this.$refs.dialogPage.clear();
        this.$refs.dialogPage.close();
      }
      ,
      netTypeFormat(grids, data) {
        return this.gridTypeEnum.netType[data.netType];
      },
    }
    ,
    provide: {
      grid: [Edit, Reorder, Resize, ContextMenu]
    }
    ,
  }
  ;
</script>

<style scoped>

</style>
